// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","large":"only screen and (min-width: 992px)","headerWrap":"D1xXg","title":"vU2S0 NJq5T"};